import { Accordion, AccordionDetails, AccordionSummary, Grid, Typography } from '@mui/material';

import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';

import { Plan, Product, Discount, OrderContext } from '@localstack/types';

import { ConstructorForm } from './ConstructorForm';

interface AdminCustomizationProps {
  edit?: boolean;
  plan: Plan;
  products: Product[];
  selectedProducts: Product[];
  discounts: Discount[];
  selectedDiscount?: Optional<Discount>;
  context: OrderContext;
  onUpdateContext?: (context: Partial<OrderContext>) => unknown;
  onUpdateDiscount?: (discount: Optional<Discount>) => unknown;
  onUpdateProducts?: (products: Product[]) => unknown;
}

export const AdminCustomization = (props: AdminCustomizationProps): JSX.Element => (
  <Grid item xs={12}>
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="subtitle1">Admin Customizations</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <ConstructorForm
          edit={props.edit}
          plan={props.plan}
          context={props.context}
          products={props.products}
          selectedProducts={props.selectedProducts}
          discounts={props.discounts}
          selectedDiscount={props.selectedDiscount}
          onUpdateContext={props.onUpdateContext}
          onUpdateDiscount={props.onUpdateDiscount}
          onUpdateProducts={props.onUpdateProducts}
        />
      </AccordionDetails>
    </Accordion>
  </Grid>
);
